export const financeProfessional = {
  id: 'finance-professional',
  version: 2,
  renderer: 'enterprise',
  name: 'Finance Professional Pro',
  layout: 'single-column',
  theme: 'slate-executive',
  persona: ['finance'],
  atsLevel: 'A+',
  scoreWeights: {
    ats: 50,
    visual: 15,
    executive: 30,
    student: 5
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'education', 'skills', 'certifications'],
  components: {
    header: 'header-centered',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-classic'
  },
  metadata: {
    industry: ['Investment Banking', 'Asset Management', 'Private Equity'],
    companies: ['Goldman Sachs', 'J.P. Morgan', 'Morgan Stanley', 'Citi', 'Merrill Lynch', 'Blackstone'],
    ats: ['Workday', 'Taleo', 'SuccessFactors'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: false,
    columns: 1,
    centeredHeader: true,
    experienceLevel: ['Mid-level', 'Senior', 'Executive'],
    careerStage: 'Professional',
    recommendedFor: ['Financial Analysts', 'Investment Bankers', 'Portfolio Managers', 'Treasury Officers'],
    avoidFor: ['Creative Directors', 'Software Engineers', 'UI/UX Designers'],
    dna: ['Traditional-Slate', 'ATS-Perfect', 'Investment-Banking', 'Serif-Dense', 'Centered-Header'],
    metrics: {
      readingDifficulty: 99,
      scanningSpeed: 99,
      visualAppeal: 81
    },
    hiringManager: {
      firstImpression: "Highly professional, analytical finance expert with structured pedigree",
      scanningStyle: "Strict top-to-bottom scan looking for financial metrics, transaction sizes, and degrees",
      preferredStructure: "Summary, experience, education, skills, certifications",
      dislikes: ["Soft color accents", "Visual rating grids", "Informal layouts"]
    },
    strategy: {
      goal: "Pass strict Wall Street screening standards and project analytical reliability",
      focus: "Deal transaction volumes (e.g. M&A deals), cost savings, and financial modelling skills",
      avoid: ["Gimmicky design elements", "Sidebar structures"]
    },
    psychology: {
      coreTraits: ["Trust", "Authority", "Mathematical precision", "Conservative corporate alignment"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Focus on corporate finance achievements, transaction modeling, deal sizes, and portfolio size. Use formal financial vocabulary.",
      rewriteStyle: "Formal, analytical, finance-centric"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.4,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'education', 'skills', 'certifications']
      },
      overrides: {
        '--font-family-primary': 'Georgia, serif',
        '--spacing-margin': '24px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--heading-weight': '800',
    '--border-thickness-heading': '2.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '6px',
    '--color-text-main': '#2F2F2F',
    '--color-text-light': '#777777'
  }
};
export default financeProfessional;
